export function squarify(items, x, y, w, h, out) {
  if (!items.length) return;
  if (items.length === 1) {
    out.push({ ...items[0], x, y, w, h });
    return;
  }

  const total = items.reduce((s, it) => s + it._area, 0);
  const shortSide = Math.min(w, h);
  const horizontal = w >= h;

  let row = [];
  let rowArea = 0;
  let i = 0;

  while (i < items.length) {
    const candidate = items[i];
    const newArea = rowArea + candidate._area;
    if (row.length === 0 || worst(row, shortSide, rowArea) >= worst([...row, candidate], shortSide, newArea)) {
      row.push(candidate);
      rowArea = newArea;
      i++;
    } else {
      break;
    }
  }

  const rowLen = rowArea / shortSide;
  let cursor = horizontal ? y : x;

  for (const item of row) {
    const itemLen = (item._area / rowArea) * shortSide;
    if (horizontal) {
      out.push({ ...item, x, y: cursor, w: rowLen, h: itemLen });
    } else {
      out.push({ ...item, x: cursor, y, w: itemLen, h: rowLen });
    }
    cursor += itemLen;
  }

  if (i < items.length) {
    if (horizontal) {
      squarify(items.slice(i), x + rowLen, y, w - rowLen, h, out);
    } else {
      squarify(items.slice(i), x, y + rowLen, w, h - rowLen, out);
    }
  }
}

function worst(row, side, totalArea) {
  const len = totalArea / side;
  return Math.max(...row.map((it) => {
    const h = it._area / len;
    return Math.max(len / h, h / len);
  }));
}
